import React from "react";
import dynamic from "next/dynamic";
import Text from "@/bit/components/components.text";
import Button from "@/bit/components/components.button";
import { getColor } from "@gcloud-npm/utils.enums.colors";
import style from "./style";
import Card from "../card";

const Icon = dynamic(() => import("@/bit/components/components.icon-glyph"));

const Teletipo = (props) => {
  if (!props) {
    return null;
  }
  const { orionInfo } = props;

  return (
    <div className="container teletipo-container">
      {orionInfo["Card-1"] && (
        <Card {...orionInfo["Card-1"]} >
          <div className="teletipo-content">
            {orionInfo["Glyph-1"] && (
              <div className="icon">
                <Icon {...orionInfo["Glyph-1"]} />
              </div>
            )}
            {orionInfo["Text-1"] && (
              <Text className="modal-legals-device" {...orionInfo["Text-1"]} />
            )}
          </div>
        </Card>
      )}

      {props["CustomLink-1"] && (
        <Button
          {...props["CustomLink-1"]}
          label={props["CustomLink-1"].title}
        />
      )}
      <style jsx>{style}</style>
    </div>
  );
};

export default Teletipo;
